import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Profile from './Profile';
import MobileSection from './MobileSection';
import { useAuth } from 'sections/authentication/context/UseAuth';
import { parseJwt } from 'utils/jwt';
import { useMemo } from 'react';

// ==============================|| HEADER - CONTENT ||============================== //

function useGreeting(username) {
  return useMemo(() => {
    const hour = new Date().getHours();
    const greeting = hour < 12 ? ' Good Morning' : hour < 17 ? ' Good Afternoon ' : ' Good Evening';

    const now = new Date();
    const day = now.toLocaleDateString('en-US', { weekday: 'long' });
    const date = now.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

    return { greeting, dayDate: `${day}, ${date}` };
  }, []);
}

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { user } = useAuth();
  const token = user?.token;
  const payload = useMemo(() => (token ? parseJwt(token) : null), [token]);
  const email = payload?.sub || '';
  const username = email.split('@')[0] || 'User';
  const { greeting, dayDate } = useGreeting(username);

  return (
    <>
      {/* pushes profile to the right */}
      <Box sx={{ flexGrow: 1 }} />
      {!downLG && (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', ml: 2, mr: 2 }}>
          <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: 'text.primary', lineHeight: 1.3 }}>{greeting}</Typography>
          <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', lineHeight: 1.3 }}>{dayDate}</Typography>
        </Box>
      )}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
